import axios from "axios";
import LoginService from './acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/relatorio/';
//const CLIENT_URL = process.env.VUE_APP_BASE_URL_CLIENT;

class ReportService {
  constructor() {
    this.idCliente = null;
    LoginService.currentUser.subscribe(data => {
      this.token = data;
    });
  }

  imprimir(rel, parametros, tipo = "pdf") {
    if (tipo === 'xls') {
      return this.download(rel, parametros, tipo);
    }
    return axios({
      url: API_URL + "export",
      method: "POST",
      responseType: "blob",
      data: {
        rel: rel,
        tipo: tipo,
        parametros: parametros
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + (this.token ? this.token.token : '')
      }
    }).then(response => {
      var fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      window.open(fileURL);
      console.log(response.data);
    });
  }

  download(rel, parametros, tipo = "pdf") {
    return axios({
      url: API_URL + "export",
      method: "POST",
      responseType: "blob",
      data: {
        rel: rel,
        tipo: tipo,
        parametros: parametros
      },
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + (this.token ? this.token.token : '')
      }
    }).then(response => {
      let appType = "application/pdf";
      if (tipo === 'xls') {
        appType = "application/msexcel";
      }
      var fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: appType })
      );
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      console.log(response);
      fileLink.setAttribute("download", rel + "." + tipo);
      document.body.appendChild(fileLink);
      fileLink.click();
    });
  }

  downloadXml(id) {
    this.idCliente = LoginService.currentUserValue.usuario.idCliente;
    return axios({
      url: API_URL + "exportXmlNFS?idNotaFiscal=" + id + "&idCliente=" + this.idCliente,
      method: "POST",
      responseType: "blob",
      data: null,
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + (this.token ? this.token.token : '')
      }
    }).then(response => {
      var fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/xml" })
      );
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      console.log(response);
      fileLink.setAttribute("download", "NotaFiscal.xml");
      document.body.appendChild(fileLink);
      fileLink.click();
    });
  }

  downloadListXmlCompleto(idContribuinte, dataIni, dataFim, docTomador, idServicoItem, root, situacao, tipo) {
    this.idCliente = LoginService.currentUserValue.usuario.idCliente;
    return axios({
      url: API_URL + "exportListXmlNFSCompleto?idCliente=" + this.idCliente + "&idContribuinte=" + idContribuinte + "&dataIni=" + dataIni + "&dataFim=" + dataFim + "&docTomador=" + docTomador + "&idServicoItem=" + idServicoItem + "&situacao=" + situacao + "&tipo=" + tipo,
      method: "POST",
      data: '',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + (this.token ? this.token.token : '')
      }
    }).then(response => {
      var fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/xml" })
      );
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      console.log(response);
      fileLink.setAttribute("download", "NotasFiscais.xml");
      document.body.appendChild(fileLink);
      fileLink.click();
    },
      (error) => {

        if (error.response && error.response.data) {
          root.$emit("alert:warn", error.response.data);
        } else {
          root.$emit("alert:warn", "Erro ao efetuar o download!");
        }

      });
  }

  downloadListXml(idContribuinte, dataIni, dataFim) {
    this.idCliente = LoginService.currentUserValue.usuario.idCliente;
    return axios({
      url: API_URL + "exportListXmlNFS?idCliente=" + this.idCliente + "&idContribuinte=" + idContribuinte + "&dataIni=" + dataIni + "&dataFim=" + dataFim,
      method: "POST",
      responseType: "blob",
      data: '',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + (this.token ? this.token.token : '')
      }
    }).then(response => {
      var fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/xml" })
      );
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      console.log(response);
      fileLink.setAttribute("download", "NotasFiscais.xml");
      document.body.appendChild(fileLink);
      fileLink.click();
    });
  }

  downloadListXmlTomador(idContribuinte, dataIni, dataFim, situacao, root) {
    this.idCliente = LoginService.currentUserValue.usuario.idCliente;
    return axios({
      url: API_URL + "exportListXmlNFSTomador?idCliente=" + this.idCliente + "&idContribuinte=" + idContribuinte + "&dataIni=" + dataIni + "&dataFim=" + dataFim + "&situacao=" + situacao,
      method: "POST",
      data: '',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + (this.token ? this.token.token : '')
      }
    }).then(response => {
      var fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/xml" })
      );
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      console.log(response);
      fileLink.setAttribute("download", "NotasFiscais.xml");
      document.body.appendChild(fileLink);
      fileLink.click();
    },
      (error) => {
        console.log(error.response.data);
        if (error.response && error.response.data) {
          root.$emit("alert:warn", error.response.data);
        } else {
          root.$emit("alert:warn", "Erro ao efetuar o download!");
        }

      });
  }

  downloadExportacoesMaiorPer(idSolicitacao, root) {
    this.idCliente = LoginService.currentUserValue.usuario.idCliente;
    return axios({
      url: API_URL + "downloadExport?idSolicitacao=" + idSolicitacao,
      method: "POST",
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        "authorization": "Bearer " + (this.token ? this.token.token : ""),
      },
    }).then(response => {
      const contentType = response.headers["content-type"];
      let fileName = "NotasFiscais.xml";

      if (contentType === "application/zip") {
        fileName = "NotasFiscais.zip";
      }

      const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", fileName);
      document.body.appendChild(fileLink);
      fileLink.click();
      console.log(fileLink);
    }).catch(error => {
      if (error.response && error.response.data) {
        root.$emit("alert:warn", error.response.data);
      } else {
        root.$emit("alert:warn", "Erro ao processar exportação!");
      }
    });
  }

  downloadExportacoesZip(idSolicitacao, root, dataIni, dataFim) {
    return axios({
      url: API_URL + "downloadZip?idSolicitacao=" + idSolicitacao,
      method: "POST",
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        "authorization": "Bearer " + (this.token ? this.token.token : ""),
      },
    }).then(response => {
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "ExportacaoNfse" + " _ " + dataIni + " _ " + dataFim + ".zip";

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="(.+)"/);
        if (match) {
          fileName = match[1];
        }
      }

      const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: "application/zip" }));
      const fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", fileName);
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    }).catch(error => {
      if (error.response && error.response.data) {
        root.$emit("alert:warn", error.response.data);
      } else {
        root.$emit("alert:warn", "Erro ao processar exportação ZIP!");
      }
    });
  }

  // downloadResourceClient(nomeArquivo) {
  //   return axios({
  //     url: CLIENT_URL+"/src/assets/" + nomeArquivo,
  //     method: 'GET',
  //     responseType: 'blob',
  //     headers: {
  //       'Content-Type':'application/json',
  //       'authorization':'Bearer ' + (this.token ? this.token.token:'')
  //     }
  //   }).then((response) => {
  //     var fileURL = window.URL.createObjectURL(
  //       new Blob([response.data], { type: "application/zip" })
  //     );
  //     var fileLink = document.createElement("a");
  //     fileLink.href = fileURL;
  //     fileLink.setAttribute("download", "layout_rps_2.04.zip");
  //     document.body.appendChild(fileLink);
  //     fileLink.click();
  //   });
  // }

  downloadResourceServer(nomeArquivo) {
    return axios({
      url: API_URL + "download?arquivo=" + nomeArquivo,
      method: 'POST',
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + (this.token ? this.token.token : '')
      }
    }).then((response) => {
      var fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/zip" })
      );
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", nomeArquivo);
      document.body.appendChild(fileLink);
      fileLink.click();
    });
  }

}

export default new ReportService();
